/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
*/
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyB8vo27vzb1tF4rN4qBsJszzGMXZtNLhrw",
  authDomain: "vernikaai.firebaseapp.com",
  projectId: "vernikaai",
  storageBucket: "vernikaai.firebasestorage.app",
  messagingSenderId: "332007669888",
  appId: "1:332007669888:web:52df57306530ea1e57e665",
  measurementId: "G-OK1HPZRQYJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Configure Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export default app;


